import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";

function AllTeamsList() {
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const response = await axios.get(
          `${config.BASE_URL}/api/admin/get-teams`
        );
        if (Array.isArray(response.data)) {
          setTeams(response.data); 
        } else {
          setError("Unexpected response format");
        }
        
      } catch (err) {
        setError("Failed to fetch teams");
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  return (
    <>
      <div className="dashboard">
        <div className="container">
          <h1 className="dash_title">Team Members</h1>
          <div className="add_project d-flex" style={{justifyContent: "flex-end", marginBottom: "20px"}}>
            <Link to="/admin/add-team">Add Team Member</Link>
          </div>
          <div className="main-section">
            <div className="projects">
              <div className="projects-inner">
                <table className="projects-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Position</th>
                      <th className="text-right">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="4">Loading...</td>
                      </tr>
                    ) : error ? (
                      <tr>
                        <td colSpan="4">{error}</td>
                      </tr>
                    ) : (
                      teams.map(
                        (
                          team,
                          index
                        ) => {
                          return (
                            <tr key={team._id}>
                              <td>
                                <p>{team.title}</p>
                              </td>{" "}
                              <td>
                                <p>{team.position}</p>{" "}
                              </td>
                              <td>
                                <Link
                                  to={`/admin/team/${team._id}`}
                                  className="view_detail"
                                >
                                  View Details
                                </Link>
                                {'   '}
                                <Link
                                  to={`/admin/update-team/${team._id}`}
                                  className="view_detail"
                                >
                                  Edit
                                </Link>
                              </td>
                            </tr>
                          );
                        }
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AllTeamsList;
